export enum SearchFieldKeys {
  Any = "Any",
  ForSale = "For Sale",
  ForRent = "For Rent",
  Residential = "Residential",
  ResidentialLease = "ResidentialLease",
}
